import React, { useEffect, useState } from 'react';
import '../styles/Header.css';
import Navigation from './Navigation';

const Header = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  // Handle image loading
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <>
      <Navigation />
      
      {/* Hero Section */}
      <section className="hero-section">
        {/* Show loading state until image loads */}
        {!imageLoaded && (
          <div className="loading-placeholder" 
            style={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              width: '100%', 
              height: '100%', 
              backgroundColor: '#f0f0f0',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 5
            }}
          >
            <div>Chargement...</div>
          </div>
        )}
        
        {/* Background Image with responsive loading */}
        <div className="hero-background">
          <img 
            src="/assets/images/Main Hero LGM.png" 
            alt="LGM Équipement de construction"
            className="landscape-image" 
            onLoad={handleImageLoad}
            loading="eager"
          />
        </div>
      </section>
    </>
  );
};

export default Header;